const windowSizes = { x: 0 , y: 0 };
const tabletBreakPoint = 860;
const debug = false;

document.addEventListener( 'DOMContentLoaded' , () => {
    initCollectionGridSliders( debug );
    initPdfPricing( debug );
});

function setCurrentWindowDimensions() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    windowSizes.x = width;
    windowSizes.y = height;
    return;
}
  
function logCurrentWindowDimensions( showConsole = false ) {
    if ( showConsole ) {
        console.log( windowSizes );
    }
    return;
}
  
function isSlickInit( element ) {
    if ( element.classList.contains( 'slick-initialized' ) ) {
        return true;
    }
    return false;
}
  
function initSlick( className , enableArrows ) {
    let arrows = false;
    if ( enableArrows == 'true') {
        arrows = true;
    }
    const widthOfArrows = 15;

    let prevArrow = `<button class="slick-prev"><svg width="${widthOfArrows}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path fill="#bb2025" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>`;
    let nextArrow = `<button class="slick-next"><svg width="${widthOfArrows}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path fill="#bb2025" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>`;

    $( className ).slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        autoplay: !arrows,
        autoplaySpeed: 2000,
        dots: false,
        arrows: arrows,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1,
                    autoplay: !arrows,
                    autoplaySpeed: 2000,
                    dots: false,
                    arrows: arrows,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow
                }
            }
        ]
    });
    return;
}

function destroySlick( className ) {
    $( className ).slick('unslick');
    return;
}

function initCollectionGridSliders( showConsole = false ) {
    setCurrentWindowDimensions();
    logCurrentWindowDimensions( showConsole );

    if ( showConsole ) {
        console.log( 'initializing Collection Grid Sliders' ); 
    }

    const hpCollectionGrids = document.querySelectorAll('[data-enable-slideshow="true"]');
    for ( let slider of hpCollectionGrids ) {
        const currentUniqueClass = slider.classList[ slider.classList.length - 1 ];
        if ( windowSizes.x < tabletBreakPoint && ( isSlickInit( slider ) == false ) ) {
            //run slick
            const enableArrows = slider.getAttribute('data-enable-slideshow-arrows');
            initSlick( `.${currentUniqueClass}` , enableArrows );
        } else if ( windowSizes.x >= tabletBreakPoint && isSlickInit( slider ) == true ) { 
            // check if slick exists and we are above the threshold
            destroySlick( `.${currentUniqueClass}` );
        }
    }

    return;
}

function initPdfPricing( showConsole = false ) {
    console.log( 'initPdfPricing' );

    // find button for the download and attach event
    const pricingRequestButton = document.querySelector( '[data-toggle-pricing]' );
    if ( pricingRequestButton != null ) {
        pricingRequestButton.addEventListener( 'click' , openAddressSelectionModal );
    }

    const closeModalButtons = document.querySelectorAll( '[data-close-address-modal]' );
    for ( let i = 0; i < closeModalButtons.length; i++ ) {
        closeModalButtons[i].addEventListener( 'click' , closeAddressSelectionModal );
    }

    const submitModalButton = document.querySelector('[data-submit-address-modal]');
    if ( submitModalButton != null ) {
        submitModalButton.addEventListener( 'click' , buildPDF );
    }

    const updateRateModalButton = document.querySelector('[data-submit-rate]');
    if ( updateRateModalButton != null ) {
        updateRateModalButton.addEventListener( 'click' , submitRate );
    }
}

function openAddressSelectionModal( e ) {
    e.preventDefault();

    const modalToClose = document.querySelector('#address-selection-modal');
    if ( modalToClose != null ) {
        modalToClose.classList.remove( 'hidden' );
    }

    document.body.classList.add('frozen');

    return;
}

function closeAddressSelectionModal( e ) {
    e.preventDefault();

    const modalToClose = document.querySelector('#address-selection-modal');
    if ( modalToClose != null ) {
        modalToClose.classList.add( 'hidden' );
    }

    document.body.classList.remove('frozen');

    const contentExportId = "pdf-export-content";
    const contentToExport = document.getElementById( contentExportId );
    const contentToExportBox = document.getElementById( 'preview-pdf-box' );
    const modalInjectPoint = document.querySelector( '#address-selection-modal #rate-options' );
    const loaderEl = document.querySelector('[data-loader]');

    if ( contentToExport != null ) {
        contentToExport.classList.remove('visible');
    }

    if ( contentToExportBox != null ) {
        contentToExportBox.classList.add('hidden');
    }

    if ( modalInjectPoint != null ) {
        modalInjectPoint.innerHTML = '';
    } 

    if ( loaderEl != null ) {
        loaderEl.classList.add('hidden');
    }

    const addressInputs = document.querySelectorAll( '#address-selection-form fieldset input' );
    for ( i = 0; i < addressInputs.length; i++ ) {
        addressInputs[i].removeAttribute( 'disabled' );
    }


    toggleButton( false , '#address-selection-modal [data-submit-rate]' );
    toggleButton( true , '#address-selection-modal [data-submit-address-modal]' );

    return;
}

async function buildPDF( e ) {
    e.preventDefault();

    // set buttons to loading in modal
    toggleButtons( false );

    // get rates
    const addressSelected = document.querySelector( '#address-selection-form input:checked' );
    if ( addressSelected == null ) {
        toggleButtons( true );

        return;
    }

    const address = {
        country: addressSelected.getAttribute('data-country'),
        province: addressSelected.getAttribute('data-province'),
        zip: addressSelected.getAttribute('data-zip')
    }

    await getLatestPDFTemplate();
    const rates = await getShippingRates( address );
    loadRatesIntoModal( rates );

    const addressInputs = document.querySelectorAll( '#address-selection-form fieldset input' );
    for ( i = 0; i < addressInputs.length; i++ ) {
        addressInputs[i].setAttribute( 'disabled' , 'true' );
    }

    toggleButtons( true );
    toggleButton( true , '#address-selection-modal [data-submit-rate]' );
    toggleButton( false , '#address-selection-modal [data-submit-address-modal]' );
}

async function getLatestPDFTemplate( ) {
    // call the shopify sections api to get the section called 'pdf-pricing'
    // replace #pdf-export-content in current view with one from fetched section

    try {
        const response = await fetch('/?section_id=pdf-pricing');

        if (!response.ok) {
            console.error('Failed to fetch pdf-pricing section');
            return;
        }

        const html = await response.text();

        // Create a temporary container to parse the response HTML
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newContent = temp.querySelector('#pdf-export-content');
        const currentContent = document.querySelector('#pdf-export-content');

        if (newContent && currentContent) {
            currentContent.replaceWith(newContent);
            console.log('PDF template updated.');
        } else {
            console.warn('Could not find #pdf-export-content in either the response or current DOM.');
        }

    } catch (error) {
        console.error('Error fetching PDF template:', error);
    }

    return;
}

function loadRatesIntoModal( rates ) {
    const modalInjectPoint = document.querySelector( '#address-selection-modal #rate-options' );
    if (!modalInjectPoint || !Array.isArray(rates) || rates.length === 0) {
        return;
    }

    modalInjectPoint.innerHTML = '<h2 class="h1 rate-options-title">Select a Shipping Method</h2>';

    for ( let index = 0; index < rates.length; index++ ) {
        const rate = rates[ index ];
        const id = `rate-option-${index}`;
        const labelText = `${rate.presentment_name} - $${parseFloat(rate.price).toFixed(2)}`;

        const label = document.createElement('label');
        label.className = 'rate-option';
        label.htmlFor = id;

        const input = document.createElement('input');
        input.type = 'radio';
        input.id = id;
        input.name = 'shipping-rate';
        input.value = rate.code;
        input.dataset.price = rate.price;
        input.dataset.presentmentName = rate.presentment_name;
        
        if ( index === 0 ) {
            input.checked = true;
        }

        const span = document.createElement('span');
        span.textContent = labelText;

        label.appendChild(input);
        label.appendChild(span);
        modalInjectPoint.appendChild(label);
    }

    return;
}

function toggleButton( enabled , selector ) {
    const btn = document.querySelector( selector );
    if ( btn != null ) {
        if ( enabled ) {
            btn.classList.remove( 'hidden' );
        } else {
            btn.classList.add( 'hidden' );
        }
    }
}

function toggleButtons( state ) {
    const buttons = document.querySelectorAll( '#address-selection-modal button' );

    for ( let i = 0; i < buttons.length; i++ ) {
        if ( state ) {
            buttons[i].removeAttribute( 'disabled' );
        } else {
            buttons[i].setAttribute( 'disabled' , 'true' );
        }
    }
}

function submitRate( e ) {
    e.preventDefault();
    updateShippingAddressInPdf();
    updateProvidedToAddressInPdf();
    updateRatesInPdf();
    handlePDFDownload();
}

function updateShippingAddressInPdf() {
    const addressSelected = document.querySelector( '#address-selection-form input:checked' );
    const contentToReplace = document.querySelector( '#shipping-address-lines' );

    if ( !addressSelected || !contentToReplace ) return;

    const company = addressSelected.dataset.company;
    const firstName = addressSelected.dataset.firstName;
    const lastName = addressSelected.dataset.lastName;
    const line1 = company && company.trim() !== '' ? company : `${firstName} ${lastName}`.trim();

    // Line 2: Address 1 and Address 2
    const address1 = addressSelected.dataset.address1 || '';
    const address2 = addressSelected.dataset.address2 || '';
    const line2 = [ address1, address2 ].filter(Boolean).join(', ');

    // Line 3: City, Province, ZIP
    const city = addressSelected.dataset.city || '';
    const province = addressSelected.dataset.provinceCode || '';
    const zip = addressSelected.dataset.zip || '';
    const line3 = [city, province, zip].filter(Boolean).join(', ');

    // Replace content
    contentToReplace.innerHTML = `
        <div>${line1}</div>
        <div>${line2}</div>
        <div>${line3}</div>
    `;

    return;
}

function updateProvidedToAddressInPdf() {
    const addressSelected = document.querySelector( '#address-selection-form input:checked' );
    const contentToReplace = document.querySelector( '#provided-address-lines' );

    if ( !addressSelected || !contentToReplace ) return;

    const company = addressSelected.dataset.company;
    const firstName = addressSelected.dataset.firstName;
    const lastName = addressSelected.dataset.lastName;
    const line1 = company && company.trim() !== '' ? company : `${firstName} ${lastName}`.trim();

    // Line 2: Address 1 and Address 2
    const address1 = addressSelected.dataset.address1 || '';
    const address2 = addressSelected.dataset.address2 || '';
    const line2 = [ address1, address2 ].filter(Boolean).join(', ');

    // Line 3: City, Province, ZIP
    const city = addressSelected.dataset.city || '';
    const province = addressSelected.dataset.provinceCode || '';
    const zip = addressSelected.dataset.zip || '';
    const line3 = [city, province, zip].filter(Boolean).join(', ');

    // Replace content
    contentToReplace.innerHTML = `
        <div>${line1}</div>
        <div>${line2}</div>
        <div>${line3}</div>
    `;

    return;
}

function updateRatesInPdf( ) {
    const selectedRate = document.querySelector('#address-selection-modal input[name="shipping-rate"]:checked');

    if ( !selectedRate ) { 
        return;
    };

    const presentmentName = selectedRate.dataset.presentmentName || '';
    const price = parseFloat(selectedRate.dataset.price || '0').toFixed(2);

    // Update "Ship Via"
    const shipViaEl = document.querySelector('#pdf-export-content .ship-via');
    if ( shipViaEl != null ) {
        shipViaEl.textContent = presentmentName;
    }

    // Update "Shipping & Handling Total"
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
    });

    const shippingTotalEl = document.querySelector('#pdf-export-content .shipping-handling-total');
    if ( shippingTotalEl != null ) {
        shippingTotalEl.textContent = formatter.format(price);
    }

    const cartTotalEl = document.querySelector('#pdf-export-content .total-cart');
    const totalWrapper = document.querySelector('#pdf-export-content [data-total]');

    if ( cartTotalEl && totalWrapper ) {
        const rawTotalCents = parseInt(totalWrapper.dataset.total, 10) || 0;
        const originalTotalDollars = rawTotalCents / 100;
        const shippingPrice = parseFloat( price ) || 0;

        const newTotal = originalTotalDollars + shippingPrice;

        cartTotalEl.textContent = formatter.format( newTotal );
    }
}

async function getShippingRates( { country , province , zip } ) {
    let rates = [];

    try {
        const shippingAddress = {
            country: country,
            province: province,
            zip: zip
        };

        const queryString = Object.keys( shippingAddress ).map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`).join('&');
        const url = `${window.Theme.routes.cart_url}/shipping_rates.json?${queryString}`;

        const response = await fetch( url );
        const results = await response.json();
        rates = results.shipping_rates;
    } catch ( error ) {
        console.error( error );
    }

    return rates;
}

function handlePDFDownload() {
    const contentExportId = "pdf-export-content";
    const contentToExport = document.getElementById( contentExportId );
    const contentToExportBox = document.getElementById( 'preview-pdf-box' );
    const loaderEl = document.querySelector('[data-loader]');
    
    if ( contentToExport === null ) {
        console.warn( `Tried to export content area to pdf but content area with id: ${contentExportId} was not found.` );
        return;
    }

    if ( loaderEl != null ) {
        loaderEl.classList.remove('hidden');
    }

    contentToExport.classList.add('visible');
    if ( contentToExportBox != null ) {
        contentToExportBox.classList.remove('hidden');
    }

    const filename = "download.pdf";
    const pdfOptions = {
        margin: 0,
        filename: filename,
        image: { 
            type: 'jpeg',
            quality: 0.98 
        },
        html2canvas: { 
            scale: 2 
        },
        jsPDF: { 
            unit: 'in', 
            format: 'letter', 
            orientation: 'portrait' 
        }
    };

    try {
        setTimeout(() => {
            html2pdf().set( pdfOptions ).from( contentToExport ).save().then( () => {
                const closeModalButton = document.querySelector( '[data-close-address-modal]' );
                if ( closeModalButton ) {
                    closeModalButton.dispatchEvent( new Event('click') );
                }
            });
        } , 3000 );
    } catch ( error ) {
        console.warn( 'Tried to export content area to pdf but failed. See Error for details.' );
        contentToExport.classList.remove('visible');
        console.error( error );
    }

    return;
}

window.addEventListener( 'resize' , ( ) => {
    initCollectionGridSliders( debug );
});
